import ApiService from "../../../services/api.service";

const ExpiredItems = {
	writeOffSelectedItems(items) {
		return ApiService.post(`/warehouse-document/write-off/expired-items`, items)
	}
}

export default ExpiredItems
